<template>
  <el-dialog width="500px"
             append-to-body
             :visible.sync="visible"
             :show-close="false"
             :canResize="false"
             class="module-upgrade-log__modal-in-tab"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             modal-class="module-upgrade-log__modal"
             custom-class="module-upgrade-log__dialog">
    <div class="module-upgrade-log__dialog__header">
    </div>
    <div class="module-upgrade-log__dialog__body">
      <div class="module-upgrade-log__dialog__body-title">
        <div class="time-title"><img :src="timeImgSrc" />
          <div>升级时间：{{ log.creationDate | minute }}</div>
        </div>
        <div class="leader-box">
          <span>产品负责人：{{ log._prodactNames }}</span>
          <span>业务负责人：{{ log._businessNames }}</span>
          <span v-if="log._uiNames">UI负责人：{{ log._uiNames }}</span>
        </div>
      </div>
      <el-scrollbar ref="scrollBox"
                    wrap-class="el-scrollbar__wrap--hidden-default">
        <div class="module-upgrade-log__dialog__body-content">
          <!-- <span style="color: var(--g-color-primary);">更新日志</span> -->
          <span v-if="log.notifyTitle">{{ log.notifyTitle }}</span>
          <div v-if="log.upgradeLogDetails && log.upgradeLogDetails.length"
               class="log-content__new">
            <div class="content-title">更新日志：</div>
            <div v-for="(detailItem, detailIndex) in log.upgradeLogDetails"
                 :key="detailIndex"
                 class="log-content-item">
              <span class="circle"></span>
              <span class="content">{{detailItem.content}}</span>
              <img :src="userImgSrc"
                   alt="">
              <span class="employee">{{detailItem.demandEmployeeName}}</span>
            </div>
          </div>
          <div v-else
               v-html="formatContent(log.content)"
               @click.stop="clickImg"></div>
        </div>
      </el-scrollbar>
    </div>
    <div class="module-upgrade-log__dialog__footer el-dialog__footer" v-if="visible">
      <el-button type="primary"
                 @click="updatePage"
                 v-show="!showKnowBtn">立即更新</el-button>
      <el-dropdown :placement="'top-start'"
                   :trigger="'hover'"
                   @command="handleMenuClick"
                   style="margin-left: 12px;"
                   v-show="!showKnowBtn && showDelayBtn">
        <div class="el-dropdown-link">
          <el-button slot="reference">稍后更新</el-button>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in remindTimeList"
                            :key="item.value"
                            :command="item.value">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary"
                 @click="iKnow"
                 v-show="showKnowBtn">知道了</el-button>
    </div>

    <el-dialog ref="dialog"
               v-bind="dialogOption"
               @close="closeDialog"
               :visible.sync="dialogOption.show">
      <div class="kye-dialog-body">
        <kye-image :config="imgConfig"></kye-image>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import moment from 'moment'
  const nowDate = new Date().getTime()
  console.log('[系统时间]', moment(nowDate).format('YYYY-MM-DD HH:mm:ss'), nowDate)

  const cacheLogMap = {}
   // 本地存储日志
  const setCacheLog = (path, log) => {
    cacheLogMap[path] = log
  }
  const removeCacheLog = (path) => {
    delete cacheLogMap[path]
  }
  // 选择暂不跟新 缓存菜单路径 和
  const notUpdatedMap = {}
  const setNotUpdated = (path, time) => {
    notUpdatedMap[path] = time
  }
  const removeNotUpdated = (path) => {
    delete notUpdatedMap[path]
  }

  export default {
    name: 'module-upgrade-log',
    data () {
      return {
        visible: false,
        log: {
          content: '',
          _prodactNames: '',
          _businessNames: '',
          _uiNames: '',
          creationDate: '',
          notifyTitle: ''
        },
        timer: null,
        showKnowBtn: false,
        showDelayBtn: true,
        remindTimeList: [
          { label: '1小时后提醒我', value: '60' },
          { label: '3小时后提醒我', value: '180' },
          { label: '6小时后提醒我', value: '360' },
          { label: '暂不更新', value: '0' }
        ],
        imgConfig: {
          height: 500,
          imgSrc: '',
          index: 0
        },
        userImgSrc: require('./images/user.png'),
        timeImgSrc: require('./images/time.png'),
        dialogOption: {
          width: '1200px',
          title: '',
          show: false,
          view: ''
        }
      }
    },
    mounted () {
      // 检测页面是否有操作，无操作，则不轮询
      this.mouseXY = ''
      this.oldMouseXY = ''
      this.path = '/'
      this.oldPath = ''
      localStorage.setItem('upgradeLogDelayTime', '')
      // 始终在菜单加载完成后，处理升级日志红点
      this.$bus.$on('APP_LOADED', this.getUpgradeLogAll)
      // websocket推送
      this.$bus.$on('GLOBAL_MODULE_LOG', this.getLogByWebsocket)
      // 监听tag关闭事件
      this.$bus.$on('GLOBAL_MENU_CLOSE', this.handleCloseTag)
      window.addEventListener('mousemove', this.mouseMoveEvent)
    },
    beforeDestroy () {
      window.removeEventListener('mousemove', this.mouseMoveEvent)
    },
    watch: {
      $route (val, oldVal) {
        let path = val.meta.tag
        if (path) {
          this.path = path
          this.oldPath = oldVal.meta.tag || ''
          if (cacheLogMap[path]) {
            //  恢复初始按钮状态
            this.showKnowBtn = false
            this.showDelayBtn = true
            this.showLog(cacheLogMap[path])
          } else {
            this.visible = false
            this.checkUpgradeByRoute(path)
          }
        } else {
          this.visible = false
          this.clearInterval()
        }
      },
    },
    methods: {
      latestUpgradeDate () {
        let last = localStorage.getItem('latestUpgradeDate')
        if (last && !/^\{/.test(last)) {
          localStorage.removeItem('latestUpgradeDate')
        }
        return JSON.parse(localStorage.getItem('latestUpgradeDate') || '{}')
      },
      // 轮询获取所有日志
      async getUpgradeLogAll () {
        this.logList = await this.$http('system.upgradeLog.all', null, { cancel: true, axios: { headers: { 'X-menu-id': '2820215716730110' } } })
        if (this.logList.length) {
          let reminds = []
          // 遍历接口存储的所有日志，记录红点逻辑
          this.logList.forEach(t => {
            if (this.$store.state.menus[t.menuCode]) {
              reminds.push({ key: t.menuCode, value: this.isUpgradeLog(t) })
            }
          })
          this.$store.commit('SET_MENUS_REMIND', reminds)
          if (this.path || this.$route.path === '/') {
            this.checkUpgradeByRoute(this.path || '/')
          }
        }
      },
      // 已经通知的用户，且最新通知不是之前的通知 或者 未收到通知，七天内收到的最新通知
      isUpgradeLog (item) {
        const c = this.latestUpgradeDate()
        let lastDate = parseInt(moment().subtract(7, 'days').format('x'))
        if (parseInt(c[item.moduleId]) > lastDate) {
          lastDate = parseInt(c[item.moduleId])
        }

        return item.read ? false : lastDate < new Date(item.creationDate).getTime()
      },
      // 校验日志列表是否包含当前路由
      checkUpgradeByRoute (path) {
        const { menus } = this.$store.getters
        const { remindMenus } = this.$store.state
        // 判断是否包含remind路由，包含则为普通通知0的情况
        if (remindMenus[path] && menus[path]) {
          this.getLogByModule(menus[path].id)
        } else {
          this.pollLog(path)
        }
      },
      // 普通提示弹窗
      async getLogByModule (id) {
        try {
          const newLog = await this.$http('system.upgradeLog.detail', { moduleId: id, dateType: 1 }, { log: false, cancel: true })
          //  对比 选择暂不跟新时间 与 最新跟新日志时间 如果最新跟新时间 小于 选择暂不跟新时间 就不提示
          if (notUpdatedMap[this.path] && (notUpdatedMap[this.path] >= new Date(newLog.creationDate).getTime())) {
            return
          }
          this.showLog(newLog)
        } catch (error) {
          console.log(error)
        }
      },
      getLogByWebsocket (data) {
        const tag = this.path
        const menuCode = data.menuCode
        if (!this.$store.state.menus[menuCode]) {
          return
        }

        // 有稍后更新，无需提示
        let menuDelay = this.getMenuDelay()
        menuDelay = menuDelay[data.moduleId]
        if (menuDelay) {
          return
        }

        // 撤回
        if (+data.status === 2) {
          this.$store.commit('SET_MENUS_REMIND', [{ key: menuCode, value: false }])
          return
        }

        // 当前模块接受到推送消息需立即谈
        if (tag === menuCode) {
          this.showLog(data)
        } else {
          this.$store.commit('SET_MENUS_REMIND', [{ key: menuCode, value: true }])
        }
      },
      showLog (log) {
        if (!log || !log.id) {
          return
        }

        // 判断当前的窗口是不是顶层窗口，如果为false，则代码是在iframe内执行
        if (window.self !== window.top) {
          return
        }

        if (!this.isUpgradeLog(log)) {
          return
        }

        this.handleLog(log)
        removeNotUpdated(this.path)
        setCacheLog(this.path, this.log)
        // 模块是否是最新代码 true是最新代码 false 则为不是
        let isLastJs = new Date(log.creationDate).getTime() < nowDate
        // 如果本地静态资源刷新，但是有升级通知，降级处理
        // 如果是最新代码并且是仅通知 升级通知，降级处理，展示为仅通知
        if (isLastJs) {
          this.showKnowBtn = true
          this.visible = true
          this.clearInterval()
          return
        }
        if (!isLastJs) {
          this.showKnowBtn = String(log.notifyType) === '0'
          if (String(log.notifyType) === '2') {
            this.showDelayBtn = false
          }
          this.visible = true
          this.clearInterval() // 有弹窗显示时，无需轮询，避免弹窗多次出现
        }
      },
      // 直接关闭提示 不再显示
      iKnow () {
        this.reportRead(this.log.id)
        this.visible = false
        removeCacheLog(this.path)
        this.$store.commit('SET_MENUS_REMIND', [{ key: this.log.menuCode, value: false }])
        this.updateLocalStorage()
        this.pollModuleLog({ id: this.log.moduleId })
      },
      // 上报用户已阅读数据
      reportRead (logId) {
        try {
          this.$http('system.upgradeLogRead.read', { upgradeLogId: logId }, { log: false, cancel: true })
        } catch (error) {
          console.log('error', error)
        }
      },
      // 更新本地缓存更新时间
      updateLocalStorage () {
        let c = this.latestUpgradeDate()
        // 得改成当前操作的时间戳
        c = { ...c, [this.log.moduleId]: new Date(this.log.creationDate).getTime() }
        localStorage.setItem('latestUpgradeDate', JSON.stringify(c))
      },
      // 等待更新
      waitUpdatePage () {
        this.visible = false
        removeCacheLog(this.path)
        this.pollLog(this.path)
      },
      /**
       * 立即更新
       */
      async updatePage () {
        try {
          removeCacheLog(this.path)
          await this.reportRead(this.log.id)
        } catch (error) {
          console.error(error)
        }
        this.updateLocalStorage()
        window.__intercept__ = 0
        location.reload()
      },
      /**
       * 清除定时器
       */
      clearInterval () {
        clearInterval(this.timer)
        this.timer = null
      },
      /**
       * 轮询升级日志
       */
      pollLog (path) {
        // 当前菜单下路由不需要再次提示
        if (path === this.oldPath) {
          return
        }
        const { menus } = this.$store.getters
        if (!menus[path]) {
          return
        }
        // 延期提示相关
        let cDelay = this.getMenuDelay()
        let delayTimeStamp = cDelay[menus[path].id]
        let delayTime = 5 * 60
        let immediate = false

        // 如果存在稍后更新的操作，就到达延期时间时再发送请求
        if (delayTimeStamp) {
          let nowTimeStamp = new Date().getTime()
          // 延期时间戳 小于等于 当前时间 需要提示并清除当前id缓存
          if (delayTimeStamp <= nowTimeStamp) {
            let c = this.getMenuDelay()
            delete c[this.log.moduleId]
            localStorage.setItem('upgradeLogDelayTime', JSON.stringify(c))
          } else {
            delayTime = Math.ceil((delayTimeStamp - nowTimeStamp) / 1000)
          }
        } else {
          immediate = true
        }

        this.pollModuleLog({ time: delayTime, id: menus[path].id, immediate })
      },
      mouseMoveEvent (e) {
        this.mouseXY = `${e.x},${e.y}`
      },
      pollModuleLog ({ immediate = false, time = 5 * 60, id = '' }) {
        // 清除之前定时器
        this.clearInterval()

        const getUpgradeLog = async () => {
          // 页面长时间无操作无需获取日志
          if (this.mouseXY !== this.oldMouseXY) {
            this.oldMouseXY = this.mouseXY
            this.getLogByModule(id)
          }
        }

        // 立即获取最新日志
        if (immediate) {
          this.getLogByModule(id)
        }

        this.timer = setInterval(() => {
          getUpgradeLog()
        }, time * 1000)
      },
      /**
       * 处理当前菜单日志
       */
      handleLog (log) {
        // 兼容老数据, 多选改为单选
        let namesArr = log.version.split(',')
        let _prodactNames = namesArr[0] ? (namesArr[0].includes('、') ? namesArr[0].split('、')[0] : namesArr[0]) : ''
        let _businessNames = namesArr[1] ? (namesArr[1].includes('、') ? namesArr[1].split('、')[0] : namesArr[1]) : ''
        let _uiNames = (namesArr[2] && namesArr[2] !== '暂无') ? (namesArr[2] ? (namesArr[2].includes('、') ? namesArr[2].split('、')[0] : namesArr[2]) : '') : ''
        this.log = {
          ...this.log,
          ...log,
          _prodactNames,
          _businessNames,
          _uiNames,
        }
      },
      /**
       * 延迟时间
       */
      handleMenuClick (val) {
        this.$store.commit('SET_MENUS_REMIND', [{ key: this.log.menuCode, value: false }])
        if (val === '0') {
          this.visible = false
          removeCacheLog(this.path)
          // 暂不跟新的菜单模块 缓存当前时间
          setNotUpdated(this.path, new Date(this.log.creationDate).getTime())
          return
        }
        this.updateMenuDelay(val)
        this.waitUpdatePage()
      },
      /**
       * 更新菜单延迟更新时间，默认五分钟
       */
      updateMenuDelay (val = '5') {
        let c = this.getMenuDelay()
        let timeStamp = new Date().getTime() + Number(val) * 60 * 1000
        c = { ...c, [this.log.moduleId]: timeStamp }
        localStorage.setItem('upgradeLogDelayTime', JSON.stringify(c))
      },
      /**
       * 更新菜单延迟更新时间，默认五分钟
       */
      getMenuDelay () {
        let last = localStorage.getItem('upgradeLogDelayTime')
        if (last && !/^\{/.test(last)) {
          localStorage.removeItem('upgradeLogDelayTime')
        }
        return JSON.parse(localStorage.getItem('upgradeLogDelayTime') || '{}')
      },
      clickImg (e, index) {
        let secArr = this.getImgSrc(this.log.content)
        if (e.target.nodeName === 'IMG') {
          this.imgConfig.imgSrc = secArr
          this.imgConfig.index = secArr.findIndex(v => v === e.target.src)
          document.body.appendChild(this.$refs.dialog.$el)
          this.showDialog('Img', '图片查看', '700px')
        }
      },
      /**
       * 匹配富文本所有src
       */
      getImgSrc (rich) {
        let imgList = []
        rich.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
          imgList.push(capture)
        })
        return imgList
      },
      /**
       * 1、图片展示插入换行
       */
      formatContent (content) {
        let text = content
        text = text.replace(/<img[^>]+>/g, (str) => {
          console.log('str', str)
          return str + '</br>'
        })
        return text
      },
      /**
       * 显示弹窗
       */
      showDialog (view, title, width = '800px') {
        this.dialogOption.show = true
        this.dialogOption.view = view
        this.dialogOption.title = title
        this.dialogOption.width = width
      },
      /**
       * 关闭弹窗
       */
      closeDialog () {
        this.dialogOption = {
          show: false,
          view: null,
          title: '',
          width: '0px'
        }
      },
      handleCloseTag (ids) {
        const tags = this.$store.state.tagsView.visitedViews.map(item => item.path)
        const removeKeys = Object.keys(cacheLogMap).filter(key => !tags.includes(key))
        removeKeys.forEach(key => {
          removeCacheLog(key)
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/public/assets/scss/variable.scss";
  .el-dialog__wrapper.module-upgrade-log__modal-in-tab {
    pointer-events: none;
    overflow: hidden;
    .el-dialog {
      pointer-events: auto;
    }
  }
  .module-upgrade-log__modal {
    &.v-modal {
      left: var(--menu-width);
      top: 78px;
    }
  }
  .module-upgrade-log__dialog {
    &.el-dialog {
      background: rgba(0, 0, 0, 0);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      max-height: 75vh;
    }
    &__header {
      height: 172px;
      background-image: url("./images/upgrade-log-bg.png");
      background-size: cover;
      position: relative;
      h3 {
        position: absolute;
        top: 70px;
        left: 60px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 4px;
      }
    }
    &__body {
      padding-top: 10px;
      background-color: #fff;
      // height: 100%;
      // border-radius: 0 0 2px 2px;
      // overflow-y: hidden;
      // max-height: calc(70vh - 220px);
      font-size: 12px;
      &-title {
        border-bottom: 1px solid #e1e1e6;
        height: 50px;
        margin: 0 16px;
        .time-title {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            height: 12px;
            display: block;
            margin-right: 6px;
          }
          div {
            color: #666666;
            font-size: 12px;
          }
        }
        .leader-box {
          color: #666666;
          margin-top: 8px;
          > span {
            margin-left: 12px;
            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
      .el-scrollbar {
        // max-height: calc(75vh - 302px);
      }
      .el-scrollbar__wrap {
        // height: 100%;
        max-height: calc(75vh - 302px);
        overflow-x: hidden;
        overflow-y: auto;
        margin: 0 !important;
        // padding: 10px 16px;
      }
      .el-scrollbar__bar.is-horizontal {
        display: none;
      }
      &-content {
        color: #333333;
        padding: 10px 16px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        // max-height: calc(75vh - 302px);
        // overflow-y: auto;
        line-height: 1.5;
        > span {
          // margin-top: 10px;
          font-weight: 600;
          line-height: 1;
        }
        > div {
          margin-top: 10px;
          line-height: 20px;
          img {
            width: 240px;
            cursor: pointer;
          }
        }
        .log-content__new {
          margin-top: 0px;
          .content-title {
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            text-align: left;
            color: var(--g-color-primary);
          }
          .log-content-item {
            border: none;
            margin: 8px 0;
            font-size: 12px;
            line-height: 16px;
            .circle {
              width: 6px;
              height: 6px;
              display: inline-block;
              background: #323233;
              border-radius: 50%;
              margin-right: 6px;
              line-height: 16px;
              vertical-align: middle;
            }
            .content {
              line-height: 16px;
              vertical-align: middle;
            }
            img {
              width: 12px;
              height: 12px;
              margin: 0px 2px 0px 8px;
              vertical-align: middle;
            }
            .employee {
              color: #869ab0;
              line-height: 16px;
              vertical-align: middle;
            }
          }
        }
      }
    }
    &__footer {
      text-align: center;
      background-color: #fff;
      display: flex;
      justify-content: flex-end;
      > span {
        font-size: 12px;
        flex: 1;
        color: #333333;
        line-height: 28px;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
      .remind-time {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/module-upgrade-log.vue